<template lang="html">
  <div id="text-page">
    <section class="header-banners-section-s2">
    </section>

    <section class="container main-section" data-aos="fade-in" data-aos-duration="1000">
      <h1 class="mb-2 text-center page-title">AVISO DE PRIVACIDAD</h1>

      <p>
        Tipsong, comprometido con la protección y privacidad de sus usuarios, hace del conocimiento de estos el presente Aviso de Privacidad:
      </p>

      <br />
      <h6>1. Identidad y domicilio del responsable</h6>
      <p>
        Tipsong es responsable del tratamiento y protección de sus datos personales. Para contactarnos sobre temas relacionados con privacidad puede escribirnos a: contacto@tipsong.online
      </p>

      <br />
      <h6>2. Datos personales que recabamos</h6>
      <ul>
        <li>Nombre completo</li>
        <li>Correo electrónico</li>
        <li>Número de teléfono</li>
        <li>Información de pago (tarjetas bancarias)</li>
        <li>Ubicación geográfica</li>
        <li>Preferencias musicales e historial de navegación</li>
      </ul>

      <br />
      <h6>3. Finalidades del tratamiento de datos</h6>
      <ul>
        <li>Proveer acceso a eventos musicales, venta de boletos y registro.</li>
        <li>Gestión de compras de merchandising.</li>
        <li>Envío de promociones y novedades sobre eventos y artistas.</li>
        <li>Análisis estadístico y mejora de servicios.</li>
      </ul>

      <br />
      <h6>4. Transferencia de datos</h6>
      <p>
        Tipsong podría compartir sus datos personales con proveedores y socios para facilitar compras y servicios relacionados con eventos musicales o merchandising, garantizando la protección de su información conforme a la ley aplicable.
      </p>

      <br />
      <h6>5. Derechos ARCO</h6>
      <p>
        Usted puede ejercer los derechos de Acceso, Rectificación, Cancelación u Oposición respecto a sus datos personales, enviando una solicitud a contacto@tipsong. online
      </p>

      <br />
      <h6>6. Cambios en el Aviso</h6>
      <p>
        Tipsong se reserva el derecho a actualizar el presente Aviso. Cualquier cambio será comunicado a través de la app o correo electrónico registrado.
      </p>
    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      content: '',
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/privacidad')).then((response)=>{
        this.content = response.data;;
      }).catch((error)=>{
        console.log(error);
      })
    }
  },

  beforeMount(){
    // this.getContent();
  }
}
</script>
